export default __webpack_public_path__ + "static/media/cover-4.24f98152.webp";